<script setup>
import ExternalServiceConfigurationTable from '@frontJs/components/tables/projectManagement/customers/tenantReports/ExternalServiceConfigurationTable.vue';
import ExternalServiceUsageTable from '@frontJs/components/tables/projectManagement/customers/tenantReports/ExternalServiceUsageTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            Services externes - Clients - Gestion de projet - Datakepler
        </title>
    </Head>

    <PageTitle> Gestion de projet - Clients - Services externes </PageTitle>

    <TabLayout
        :tabs="{
            usage: {
                title: 'Utilisation',
                content: h(ExternalServiceUsageTable),
            },
            configuration: {
                title: 'Configuration',
                items: {
                    activeCustomers: {
                        title: 'Clients actifs',
                        content: h(ExternalServiceConfigurationTable),
                    },
                    archivedCustomers: {
                        title: 'Clients archivés',
                        content: h(ExternalServiceConfigurationTable, {
                            archived: true,
                        }),
                    },
                },
            },
        }"
    />
</template>
